module.exports = __webpack_public_path__ + "static/media/Urban Colors Art_2.576280a4.jpg";